import { Project } from "@brg/api";
import { COMPETITION_TYPE } from "_competition/const";

export const isCompetitionHead = (project: Project, currentCompetitionId: string, accountId: string) => {
    const competition = project?.competitions?.find((competition) => competition?.competitionId === currentCompetitionId)
    const isProjectPracticeParticipant = competition?.competitionType === COMPETITION_TYPE.Practices;
    const isCompetitionHead = competition?.headOfPracticeAccountId === accountId;
    return isProjectPracticeParticipant && isCompetitionHead
}import { Project } from "@brg/api";
import { COMPETITION_TYPE } from "_competition/const";

export const isCompetitionHead = (project: Project, currentCompetitionId: string, accountId: string) => {
    const competition = project?.competitions?.find((competition) => competition?.competitionId === currentCompetitionId)
    const isProjectPracticeParticipant = competition?.competitionType === COMPETITION_TYPE.Practices;
    const isCompetitionHead = competition?.headOfPracticeAccountId === accountId;
    return isProjectPracticeParticipant && isCompetitionHead
}